"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        paddingTop: 3
    },
    title: {
        fontFamily: 'EuclidCircularB',
        fontSize: 16,
        fontWeight: 600,
        color: theme.grey1
    },
    file: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingTop: 3,
        paddingBottom: 3,
        fontSize: 12,
        lineHeight: '18px',
        fontWeight: 400,
        color: theme.grey2,
        '&:nth-child(odd)': {
            backgroundColor: theme.grey9
        },
        '& > small': {
            fontSize: 'inherit',
            color: theme.grey3
        }
    }
});
//# sourceMappingURL=fileField.style.js.map